import React from 'react';

type UploadErrorBannerProps = {
  message: React.ReactNode;
  centered?: boolean;
  style?: React.CSSProperties;
};

const UploadErrorBanner = ({
  message,
  centered = false,
  style,
}: UploadErrorBannerProps): JSX.Element => (
  <div
    role="alert"
    style={{
      backgroundColor: '#FEF2F2',
      border: '1px solid #FECACA',
      borderRadius: '6px',
      color: '#991B1B',
      fontSize: '13px',
      lineHeight: '20px',
      padding: '12px 16px',
      textAlign: centered ? 'center' : 'left',
      ...style,
    }}
  >
    {message}
  </div>
);

export default UploadErrorBanner;
